module.exports = __webpack_public_path__ + "static/media/food.415249d3.svg";